import request from '@/utils/axios';

// 登录
export function login(data) {
  return request({
    url: '/h5/common/login',
    method: 'post',
    data,
  });
}

// 退出登录
export function logout(data) {
  return request({
    url: '/h5/common/logout',
    method: 'post',
    data,
  });
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/h5/common/getUserInfo',
    method: 'post',
  });
}

// 修改密码
export function updatePwd(data) {
  return request({
    url: '/h5/common/updatePwd',
    method: 'post',
    data,
  });
}

// 上传文件
export function fileUpload(file) {
  return request({
    url: '/h5/common/fileUpload/avatar',
    method: 'post',
    data: {
      file,
    },
    customHeaders: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

// 修改头像
export function updateAvatar(data) {
  return request({
    url: '/h5/common/updateAvatar',
    method: 'post',
    data,
  });
}

// 验证公司代码是否存在
export function verifyCompanyCode(data) {
  return request({
    url: '/h5/common/verifyCompanyCode',
    method: 'post',
    data,
  });
}

// 验证身份证是否已被注册
export function verifyIdCardNumber(data) {
  return request({
    url: '/h5/common/verifyIdCardNumber',
    method: 'post',
    data,
  });
}

// 获取工序列表数据
export function processInfoList(data) {
  return request({
    url: '/h5/common/processInfoList',
    method: 'post',
    data,
  });
}

// 注册
export function register(data) {
  return request({
    url: '/h5/common/register',
    method: 'post',
    data,
  });
}
